import api from "../api/flexapi";
import * as widgetTypes from "../components/dashboard/widgets/WidgetTypes";
import { initNotificationsWidgetNew } from "./notificationActions";
import { constructNotifications } from "../reducers/notificationReducer";

export const LOAD_DASHBOARD_BEGIN = "LOAD_DASHBOARD_BEGIN";
export const LOAD_DASHBOARD_SUCCESS = "LOAD_DASHBOARD_SUCCESS";
export const LOAD_DASHBOARD_ERROR = "LOAD_DASHBOARD_ERROR";

export const getDashboard = () => dispatch => {
  dispatch({ type: LOAD_DASHBOARD_BEGIN, payload: null });
  api
    .getDashboard()
    .then(response => {
      dispatch({ type: LOAD_DASHBOARD_SUCCESS, payload: { ...response.body } });
    })
    .catch(err => {
      dispatch({
        type: LOAD_DASHBOARD_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const getDashboardAndInitNotification = () => dispatch => {
  dispatch({ type: LOAD_DASHBOARD_BEGIN, payload: null });
  api
    .getDashboard()
    .then(response => {
      const byId = response.body.cards.reduce(
        (obj, item) => ({ ...obj, [item.id]: item.content }),
        {}
      );
      dispatch(
        initNotificationsWidgetNew(
          constructNotifications(
            byId[widgetTypes.NOTIFICATIONS],
            byId[widgetTypes.PASSWORD_INFO],
            byId[widgetTypes.HEALTH_DECLARATION_FORM]
          )
        )
      );
      dispatch({
        type: LOAD_DASHBOARD_SUCCESS,
        payload: Object.assign({ ...response.body }, { byId }),
      });
    })
    .catch(err => {
      dispatch({
        type: LOAD_DASHBOARD_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};



// WEBPACK FOOTER //
// ./actions/dashboardActions.js